<div class="group">
  <div class="group__title">{{ 'menu.accessibility' | translate }}</div>

  <div class="group__options">
    <label class="group__option group__option--without-arrow mb-0">
      <app-switch [(ngModel)]="appService.isDarkmode" class="mr-2 ml-3"></app-switch>
      <div class="group__option-name">{{ 'menu.darkMode' | translate }}</div>
    </label>
  </div>
</div>
